import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'sr_mngt_individuals_responsible_implementation_existing_prod'

export const dataPointDefinition = {
  retracedId: 'sr_mngt_individuals_responsible_implementation_existing_prod',
  name: 'Senior Management, Individuals responsible for implementation, EXISTING production workers, Security guards, Suppliers/S',
  description: '',
  meta: {
    slcpMeta: {
      key: 'ms-do-42x',
      number: 'MS-DO-11-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'ms-do-41',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[3],ms-5--1-1x;ms-5--1-2x;ms-do-29;ms-5--1-4x;ms-5--1-5x',
      machineShowHide: '[3],ms-5--1-1x;ms-5--1-2x;ms-do-29;ms-5--1-4x;ms-5--1-5x',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-do-42x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 33720,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
